// <auto-generated>
// Generated by tools/codegen-entitlements.js from schemas/entitlements.json.
// DO NOT EDIT — edit the schema + re-run the codegen.
// </auto-generated>

export type PermissionKey = "canViewAnalytics" | "canViewSponsorRoi" | "canViewPostEventReport" | "canViewAiUsage" | "canViewAiSources";
export type FeatureKey = "postEventReport" | "analytics" | "sponsorRoi" | "boothAnalytics" | "aiUsage" | "aiSources";

export interface Permission { key: PermissionKey; label: string; }
export interface Feature {
  key: FeatureKey;
  label: string;
  permission: PermissionKey;
  collections: string[];
  callables: string[];
}

/** Per-organizer permissions, in the order WebAdmin lists them: each is a boolean on the grant. */
export const PERMISSIONS: ReadonlyArray<Permission> = [
  { key: "canViewAnalytics", label: "Analytics" },
  { key: "canViewSponsorRoi", label: "Sponsor ROI" },
  { key: "canViewPostEventReport", label: "Post-event report" },
  { key: "canViewAiUsage", label: "AI Usage" },
  { key: "canViewAiSources", label: "AI Help Desk sources" },
];

export const FEATURES: Readonly<Record<FeatureKey, Feature>> = {
  postEventReport: { key: "postEventReport", label: "Post-event report", permission: "canViewPostEventReport", collections: ["organizerReport"], callables: ["computeOrganizerReport"] },
  analytics: { key: "analytics", label: "Analytics", permission: "canViewAnalytics", collections: ["analyticsSnapshots", "analytics"], callables: ["computeAnalyticsSnapshot"] },
  sponsorRoi: { key: "sponsorRoi", label: "Sponsor ROI", permission: "canViewSponsorRoi", collections: ["sponsorReports", "boothLeads"], callables: ["computeSponsorReports"] },
  boothAnalytics: { key: "boothAnalytics", label: "Booth visitor analytics", permission: "canViewAnalytics", collections: [], callables: [] },
  aiUsage: { key: "aiUsage", label: "AI Usage", permission: "canViewAiUsage", collections: ["aiUsage"], callables: [] },
  aiSources: { key: "aiSources", label: "AI Help Desk sources", permission: "canViewAiSources", collections: ["knowledgeSources"], callables: ["indexKnowledgeSource", "listKnowledgePassages", "removeKnowledgePassages"] },
};

/** Whether a grant opens the feature: the event-admin role AND the feature's permission, both exactly (a string "true" is not a permission). An unknown feature is never open. Super-admins are decided by the caller, never here. */
export function grantAllows(grant: Record<string, unknown> | null | undefined, featureKey: string): boolean {
  const feature = (FEATURES as Record<string, Feature>)[featureKey];
  if (!feature || !grant) return false;
  return grant['role'] === 'admin' && grant[feature.permission] === true;
}
